import { ILoader, ILoaderProps } from './ILoaderDecorator';
import { withScope } from '../scope/withScope';
import { createTimeoutCancelSource } from '../wait/wait';
import { raceWithCancel } from '../cancel/CancelError';
import { Scope } from '@ms/utilities-disposables/lib/Scope';

/**
 * Wraps a loader with a version which waits for a given timeout before emitting a cancellation result.
 * @public
 */
export function withTimeout<TResult>(load: ILoader<TResult>, timeout?: number | undefined): ILoader<TResult> {
  return async (props: ILoaderProps = {}): Promise<TResult> => {
    if (timeout === undefined || timeout === Infinity) {
      return await load(props);
    }

    return await withScope(async (scope: Scope) => {
      const { token } = scope.attach(createTimeoutCancelSource(timeout, props.cancelToken));

      const task = load({
        ...props,
        // Ensure that the original loader may be canceled if it times out.
        cancelToken: token
      });

      return await raceWithCancel(task, token);
    });
  };
}
